import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TextControl } from '@shared/ui/controls/text-control.model';
import { BenchTemplateItem } from '../../../shared/interfaces/entities/bench-template-item.interface';
import { BenchTemplateService } from '../services/bench-template.service';
import { AvailableItemsSelect } from '../../../shared/ui/select-controls/available-items-select.model';
import { AvailableItemFilter } from '../../../shared/interfaces/select-filters/available-item.filter.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';

@Component({
    selector: 'app-bench-template-reassign-item',
    templateUrl: './bench-template-reassign-item.component.html',
    styleUrls: ['./bench-template-reassign-item.component.css'],
    standalone: false
})
export class BenchTemplateReassignItemComponent implements OnInit {
  @Input() entity: BenchTemplateItem;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  public form: FormGroup;
  submitted: boolean = false;
  availableItems: AvailableItemsSelect;
  constructor(private fb: FormBuilder, private auth: AuthenticationService) { }

  ngOnInit() {
    this.availableItems = new AvailableItemsSelect(this.entity.epcUniqueIdentifier.toString(), "", null);

    var itemId: AvailableItemFilter = {
      ItemId: this.entity.itemId,
      OrganizationId: this.auth.getOrganizationId()
    };
    this.availableItems.filters = itemId;

    this.form = this.fb.group({
      id: this.entity.id,
      itemUniqueId: this.entity.itemUniqueId,
    });
  }

  save(): void {
    this.submitted = true;

    // If we have select fields we need to extract the ID's and set the form value (I think we have to do this separately because our select fields are a custom component)
    var clientId = this.availableItems.getValue();

    if (clientId == undefined || clientId == null || clientId.length == 0) {
      var c = document.getElementById(this.availableItems.id);
      if (c) {
        c.style.border = "2px solid orangered";
      }
      return;
    }

    this.form.controls['itemUniqueId'].setValue(clientId);
    this.submitForm.emit(this.form);
  }
}
